module.exports = __webpack_public_path__ + "img/cdea_tree.e521905f.png";